module.exports = __webpack_public_path__ + "img/sea-home.cda2a725.jpg";